import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isNativeApp } from "@/lib/native";
import { mapDeepLinkPath } from "@/lib/deeplink";

// Handles Universal Links (iOS) / App Links (Android) inside the native app.
// Reuses the existing React routes — no duplicate routing logic. No-op on web,
// where the browser already resolves the same HTTPS URLs to the same routes.
export function DeepLinkHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativeApp()) return;
    let listener;
    let cancelled = false;

    (async () => {
      const { App } = await import("@capacitor/app");

      // Cold start: the app was launched by tapping a link.
      try {
        const launch = await App.getLaunchUrl();
        const p = mapDeepLinkPath(launch?.url);
        if (p && !cancelled) navigate(p, { replace: true });
      } catch {}

      // Warm / backgrounded: a link was tapped while the app was already running.
      listener = await App.addListener("appUrlOpen", (event) => {
        const p = mapDeepLinkPath(event?.url);
        if (p) navigate(p);
      });
    })();

    return () => {
      cancelled = true;
      if (listener) listener.remove();
    };
  }, [navigate]);

  return null;
}
